import { useQuery } from '@tanstack/react-query';
import { unitsService } from '../services/units.service';

/** Minimal unit shape used by every dropdown/picker. */
export type MinimalUnit = {
  _id: string;
  name: string;
  parentUnitId?: string | null;
  unitCode?: string | null;
  appId?: string | null;
};

/** Single shared query key so ALL unit pickers read the same cache entry. */
export const UNITS_MINIMAL_QUERY_KEY = ['units', 'minimal-tree'] as const;

/**
 * Cached list of EVERY unit (minimal shape) for dropdowns/pickers across the app.
 * One React Query entry → the list-minimal API is hit once and then served from
 * cache by every consumer (Personnel, RBAC role bindings, unit tree, …).
 */
export function useMinimalUnits() {
  return useQuery<MinimalUnit[]>({
    queryKey: [...UNITS_MINIMAL_QUERY_KEY],
    queryFn: () => unitsService.getMinimalTree(),
    staleTime: 30 * 60 * 1000, // 30 min — units rarely change within a session
    gcTime: 60 * 60 * 1000,
  });
}
